import { CoveragePlanCard, CoveragePlanStatus } from '@cms-max/medicare-api-sdk'
import { useMemo } from 'react'

export function useFilterPlans (plans: Array<CoveragePlanCard> = []) {
  const filtered = useMemo(() => {
    return plans.reduce(
      (acc, plan) => {
        if (plan.status === CoveragePlanStatus.Past) {
          acc.past.push(plan)
        } else if (plan.status === CoveragePlanStatus.Future) {
          acc.future.push(plan)
        } else {
          acc.current.push(plan)
        }
        return acc
      },
      { current: [], past: [], future: [] } as {
        current: Array<CoveragePlanCard>
        past: Array<CoveragePlanCard>
        future: Array<CoveragePlanCard>
      }
    )
  }, [plans])

  return filtered
}
